import { InfoIcon } from "@/components/icons/info-icon";
import { CarbSwapsBottomSheet } from "@/features/meal-plan/components/carb-swaps-bottom-sheet";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo, useState } from "react";

interface CarbSwapTagProps {
  label: string;
  className?: string;
}

export const CarbSwapTag = memo(function CarbSwapTag({ label, className }: CarbSwapTagProps) {
  const [isCarbSwapsOpen, setIsCarbSwapsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className={cn(
          "bg-carb-option flex h-9 items-center gap-2 rounded-full py-2 pr-2 pl-4",
          className,
        )}
        onClick={() => setIsCarbSwapsOpen(true)}
        aria-label={`${label} info`}
      >
        <span className={cn(textVariants.bodySmall, "text-black capitalize")}>{label}</span>
        <InfoIcon className="relative h-5 w-5 fill-black" />
      </button>

      <CarbSwapsBottomSheet isOpen={isCarbSwapsOpen} onDismiss={() => setIsCarbSwapsOpen(false)} />
    </>
  );
});
